export enum UserState {
	ACTIVATED = 'ACTIVATED',
	DISABLED = 'DISABLED',
	PENDING = 'PENDING',
	SLEEPING = 'SLEEPING'
}
